module.exports = __webpack_public_path__ + "static/media/play.be389d8a.svg";